<script setup lang="ts">
    import { ICoachingFormQuestion } from '@/js/services/api/coachingForm/types';
    import { onMounted } from 'vue';
    import EchoButton from '../EchoButton.vue';
    import { temporaryUUID } from '@/js/composables/useTemporaryUUID';
    import { useEditCoachingFormStore } from '@/js/stores/edit-coaching-form';
    import EditCoachingFormAnswerOptions from './EditCoachingFormAnswerOptions.vue';
    import { PlusIcon } from '@lucide/vue';
    import { __ } from '@/js/stores/expressions';

    const question = defineModel<ICoachingFormQuestion>('question', { required: true });

    const { addAnswer } = useEditCoachingFormStore();

    onMounted(() => {
        if (question.value.answers.length === 0) {
            question.value.answers = [
                { id: temporaryUUID(), label: 'Detta är ett svar', points: 10 },
                { id: temporaryUUID(), label: 'Detta är ett annat svar', points: 0 },
            ];
        }
    });
</script>

<template>
    <fieldset class="block mt-6">
        <EditCoachingFormAnswerOptions :question="question" />
    </fieldset>

    <div class="mt-3">
        <EchoButton
            variant="dashed"
            size="small"
            @click="addAnswer(question, { id: temporaryUUID(), label: '', points: 0 })"
        >
            <template #icon-left><PlusIcon /></template>
            {{ __('add-answer-option') }}
        </EchoButton>
    </div>
</template>
